export default __webpack_public_path__ + "b5698a02eef37ce291467e2d87106263.svg";